import { Table, Row, Col, message, Modal, Space, Pagination } from "antd";
import { DeleteOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import axios from "axios";
import SearchProps from "../../../component/SearchProps";

export default function PlaylistDashboard() {
  const [playlists, setPlaylists] = useState([]);
  const [pagination, setPagination] = useState({ page: 1, pageSize: 10 });

  const fetchPlaylists = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/playlist/all`, { params: pagination });
      setPlaylists(res?.data || {});
    } catch {
      message.error("Lỗi tải dữ liệu!");
    }
  };

  const removePlaylist = async (id) => {
    await axios.delete(`${process.env.REACT_APP_API_URL}/playlist/admin/${id}`);
    message.success("Xóa thành công!");
    fetchPlaylists();
  };

  const confirmDelete = (id) => {
    Modal.confirm({
      icon: <ExclamationCircleOutlined />,
      content: "Bạn có chắc chắn xoá playlist này?",
      okText: "Xác nhận",
      cancelText: "Huỷ",
      onOk: () => removePlaylist(id),
    });
  };

  useEffect(() => {
    fetchPlaylists();
  }, [pagination]);

  const columns = [
    { title: "ID", dataIndex: "id", key: "id", width: 60, sorter: (a, b) => a.id - b.id },
    { title: "Tên Playlist", dataIndex: "title", key: "title", width: 250, ...SearchProps("title") },
    { title: "User ID", dataIndex: "user_id", key: "user_id", width: 100 },
    { title: "Username", dataIndex: "username", key: "username", width: 200, ...SearchProps("username") },
    {
      title: "Thao tác", key: "action", width: 80,
      render: (_, record) => (
        <Space>
          <DeleteOutlined className="text-red-500 cursor-pointer" onClick={() => confirmDelete(record.id)} />
        </Space>
      )
    },
  ];

  return (
    <>
      <Row gutter={10} className="mb-2">
        <Col flex={1}>
          <div className="text-[20px] font-medium pb-5 pt-5">Quản lý Playlist</div>
        </Col>
      </Row>
      <div className="w-full h-full mt-5 pb-20 relative">
        <Table
          className="custom-table"
          dataSource={playlists?.data}
          columns={columns}
          pagination={false}
          rowKey="id"
        />
        <Pagination
          className="flex justify-center absolute inset-x-0 bottom-10"
          current={pagination.page}
          total={playlists?.total}
          pageSize={pagination.pageSize}
          showSizeChanger
          onChange={(p, ps) => setPagination({ page: p, pageSize: ps })}
        />
      </div>
    </>
  );
}
